//appreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const ApPreset = definePreset(Aura, {

  semantic: {
    // primary: {
    //   50: '{blue.50}',
    //   100: '{blue.100}',
    //   200: '{blue.200}',
    //   300: '{blue.300}',
    //   400: '{blue.400}',
    //   500: '{blue.500}',
    //   600: '{blue.600}',
    //   700: '{blue.700}',
    //   800: '{blue.800}',
    //   900: '{blue.900}',
    //   950: '{blue.950}',
    // },
    // primary: {
    //   50:  '#e6f5eb',
    //   100: '#c8e9d3',
    //   200: '#a2dbb7',
    //   300: '#79cc99',
    //   400: '#4fbd7a',
    //   500: '#036D33', // Main shade
    //   600: '#025d2c',
    //   700: '#024d25',
    //   800: '#023d1d',
    //   900: '#012f17',
    //   950: '#001d0d',
    // },
    primary: {
      50:  '#fff6ed',
      100: '#ffebd4',
      200: '#ffd3a9',
      300: '#ffb372',
      400: '#fe7f29',
      500: '#fd6712', // Main shade
      600: '#ee4c08',
      700: '#c53709',
      800: '#9c2c10',
      900: '#7e2710',
      950: '#441006',
    },
  },
});

export default ApPreset;
